import React, { FC, useContext, useState } from 'react'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import Modal from '@components/ui/modal'
import Loader from '@components/ui/loader'
import { Field, Formik } from 'formik'
import Text from '@components/ui/text'
import TextAreaInput from '@components/requestForms/inputs/textarea.inputs'
import { SignupSchema } from './__index.utils'
import { DOSSIER_FORM } from '@components/ui/TNUrbanRequestDetails/__index.utils'
import { RepereIntegrationRepository } from '@services/repositories/_miscellaneous.repository'
import * as pageRequestDetailsUtils from '@pages/auth/requests/__[id].utils'

type Props = {
	isOpen: boolean
	dossier?: DOSSIER_FORM
	title?: string
	description?: string
	isDefaultCancelReason?: boolean
	isHomePage?: boolean
	requeteGUID?: string
	onCancel: () => void
}

const motifMax = 2000

const CancelDossierModal: FC<Props> = ({
	isOpen,
	dossier,
	onCancel,
	title,
	description,
	isHomePage,
	requeteGUID
}) => {
	const { pageData } = useContext(AppStateContext)
	const [loading, setLoading] = useState(false)
	const repereRepo = new RepereIntegrationRepository()

	const handleCancelRequest = async (motif: string) => {
		if (!dossier) return
		try {
			setLoading(true)
			await repereRepo.cancelDossierRequest({
				annee: dossier.ANNEE_DOSS,
				dossier: Number(dossier.NO_DOSS),
				motif,
				requeteGUID: requeteGUID!
			})
		} catch (err) {
			console.error(err)
		} finally {
			setTimeout(() => {
				window.location.reload()
				onCancel()
				setLoading(false)
			}, 5)
		}
	}

	return (
		<Modal
			title={title ?? `Annulation du dossier ${dossier?.NO_DOSSIER ?? ''}`}
			primaryButtonText={'Envoyer'}
			cancelButtonText={pageData?.assets?.cancel}
			showExitBtn
			isOpen={isOpen}
			onCancelBtn={onCancel}
			onPrimaryButton={() => {
				document.getElementById('cancel-dossier-submit')?.click()
			}}
			onSetIsOpen={() => {}}
			lessPadding
		>
			{loading ? (
				<Loader text={pageData?.assets?.loading} />
			) : (
				<Formik
					initialValues={{
						motif: ''
					}}
					validationSchema={SignupSchema}
					onSubmit={(values) => void handleCancelRequest(values.motif)}
					style={{ padding: '10px' }}
				>
					{({ errors, touched, setFieldValue, handleSubmit, values }) => (
						<form onSubmit={handleSubmit}>
							<label
								className={errors.motif && touched.motif ? 'text-error' : ''}
							>
								{'Pour quelle raison désirez-vous annuler ce dossier?'}
								<span className={pageRequestDetailsUtils.classes.required}>
									*
								</span>
								{errors.motif && touched.motif && (
									<div style={{ marginTop: 6 }} className="text-error">
										{pageData?.assets?.[errors.motif] ?? errors.motif}
									</div>
								)}
							</label>

							<Field name="motif">
								{() => (
									<TextAreaInput
										id="motif"
										rows={1}
										value={values.motif}
										maxCharacters={motifMax}
										onChange={(v: string) => setFieldValue('motif', v)}
										hasError={!!(errors.motif && touched.motif)}
										descriptionAlignment="left"
									/>
								)}
							</Field>

							{description && (
								<div
									style={{ paddingRight: 25, marginTop: isHomePage ? 0 : -35 }}
								>
									<Text content={description} />
								</div>
							)}

							<button
								id="cancel-dossier-submit"
								type="submit"
								style={{ display: 'none' }}
								aria-hidden
							/>
						</form>
					)}
				</Formik>
			)}
		</Modal>
	)
}

export default CancelDossierModal
